<template lang="pug">
b-modal#providerPtGlobalUpdate(
  ref="providerPtGlobalUpdate"
  :title="$t('ui.combine.provider_pt_global_update')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$tc('ui.provider_code')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="provider_code"
        type="text"
        :dirty="$v.provider_code.$dirty"
        :error="$v.provider_code.$error"
        v-model.trim.lazy="$v.provider_code.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.provider_code" :name="$t('ui.provider_code')")
    b-form-group(:label="$tc('ui.pt')").mb-0
      DebounceInput(
        size="sm"
        ref="pt"
        type="number"
        keyPressRestrict="restrictTwoDPlace"
        :dirty="$v.pt.$dirty"
        :error="$v.pt.$error"
        v-model.trim.lazy="$v.pt.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.pt" :name="$t('ui.pt')")
    //- div.row
    //-   div.col
    //-     b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, minValue, maxValue, helpers, decimal } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
  },
  props: { 
    item: {
      type: Object,
      default: null
    }
   },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      provider_code: "",
      pt: 0
    };
  },
  computed: { 
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    }
  },
  validations: {
    provider_code: {
      required
    },
    pt: {
      required,
      //numeric,
      minValue: minValue(0),
      maxValue: maxValue(100)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.providerPtGlobalUpdateUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          provider_code: this.provider_code,
          pt: this.pt
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.providerPtGlobalUpdate.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  if(response.data.status == -9) {
                    this.$emit("failed", "provider_pt_global_update", response.data.statusdesc);
                  } else {
                    this.$emit("failed", "provider_pt_global_update", this.feedback.status);
                  }
                  this.$refs.providerPtGlobalUpdate.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.provider_code = this.item.provider_code;
      this.pt = this.item.pt;
    }
  }
};
</script>
  